module.exports = __webpack_public_path__ + "images/emoji/new.434fa5a9831033053c62.png";